import { Component, Input } from '@angular/core';

@Component({
  selector: 'favourite-icon',
  template: `
    <svg width="28" height="28" viewBox="0 0 28 28" [ngClass]="{'selected-fav-svg': this.favourite, 'no-selected-fav-svg': !this.favourite}" xmlns="http://www.w3.org/2000/svg">
        <path stroke-width="2" d="M14.3667 7.85922L15.1667 8.92589L15.9667 7.85922C16.6569 6.93884 17.6193 6.25899 18.7175 5.91596C19.8156 5.57293 20.9938 5.58411 22.0853 5.94792C23.1767 6.31173 24.126 7.00972 24.7987 7.94303C25.4714 8.87634 25.8333 9.99764 25.8333 11.1481C25.8333 15.1667 23.8189 18.3293 21.3891 20.5999C19.0697 22.7673 16.4756 24.0228 15.1667 24.3779C13.8577 24.0228 11.2636 22.7673 8.94422 20.5999C6.51447 18.3293 4.5 15.1667 4.5 11.1481C4.5 9.99764 4.86198 8.87634 5.53467 7.94303C6.20736 7.00972 7.15666 6.31173 8.24809 5.94792C9.33951 5.58411 10.5177 5.57293 11.6159 5.91596C12.714 6.25899 13.6764 6.93884 14.3667 7.85922Z"/>
    </svg>
  `,
  styles: `
    .selected-fav-svg{
        stroke: red;
        fill: red;
        transition: all .15s ease-in-out;
        &:hover{
            fill: #D9D9D9;
            stroke: #666;
        }
    }

    .no-selected-fav-svg{
        stroke: #666;
        fill: rgba(0, 0, 0, 0);
        transition: all .15s ease-in-out;
        &:hover{
            fill: #ff120082;
        }
    }
  `
})

export class FavouriteIconComponent {
    @Input('favourite') favourite: boolean = false;
}
